import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {fetchRevenueReportObservable} from 'web-app/react/plans/revenue-report/epics';
import {REVENUE_TARGET_TYPES, FIRST_DAY_OF_YEAR, LAST_DAY_OF_YEAR} from 'web-app/react/plans/revenue-report/constants';

import * as Api from './api';
import * as Actions from './actions';

const fetchOccupancyDataObservable = (organizationId, refresh, year) =>
    Api.fetchOccupancyData(organizationId, refresh, year).map(data => Actions.fetchOccupancyDataSuccess.action({data}));

const fetchOccupancyData = action$ =>
    action$
        .ofType(Actions.fetchOccupancyData.type)
        .mergeMap(({payload}) =>
            fetchOccupancyDataObservable(payload.organizationId, false, payload.year).catch(e =>
                Observable.of(Actions.fetchOccupancyDataFailed.action(e)),
            ),
        );

const fetchLeaversAndJoinersObservable = (organizationId, year) =>
    Api.fetchLeaversAndJoiners(organizationId, year).map(data => Actions.fetchLeaversAndJoinersSuccess.action({data}));

const fetchLeaversAndJoiners = action$ =>
    action$
        .ofType(Actions.fetchLeaversAndJoiners.type)
        .mergeMap(({payload}) =>
            fetchLeaversAndJoinersObservable(payload.organizationId, payload.year).catch(e =>
                Observable.of(Actions.fetchLeaversAndJoinersFailed.action(e)),
            ),
        );

const fetchEnrolledDataObservable = (organizationId, year) =>
    Api.fetchEnrolledData(organizationId, year).map(data => Actions.fetchEnrolledDataSuccess.action({data}));

const fetchEnrolledData = action$ =>
    action$
        .ofType(Actions.fetchEnrolledData.type)
        .mergeMap(({payload}) =>
            fetchEnrolledDataObservable(payload.organizationId, payload.year).catch(e =>
                Observable.of(Actions.fetchEnrolledDataFailed.action(e)),
            ),
        );

const fetchRegisteredEmployeesObservable = (organizationId, year) =>
    Api.fetchRegisteredEmployees(organizationId, year).map(data =>
        Actions.fetchRegisteredEmployeesSuccess.action({data}),
    );

const fetchRegisteredEmployees = action$ =>
    action$
        .ofType(Actions.fetchRegisteredEmployees.type)
        .mergeMap(({payload}) =>
            fetchRegisteredEmployeesObservable(payload.organizationId, payload.year).catch(e =>
                Observable.of(Actions.fetchRegisteredEmployeesFailed.action(e)),
            ),
        );

const fetchEmployeeSickDaysObservable = (organizationId, year) =>
    Api.fetchEmployeeSickDays(organizationId, year).map(data => Actions.fetchEmployeeSickDaysSuccess.action({data}));

const fetchEmployeeSickDays = action$ =>
    action$
        .ofType(Actions.fetchEmployeeSickDays.type)
        .mergeMap(({payload}) =>
            fetchEmployeeSickDaysObservable(payload.organizationId, payload.year).catch(e =>
                Observable.of(Actions.fetchEmployeeSickDaysFailed.action(e)),
            ),
        );

const refreshAll = action$ =>
    action$.ofType(Actions.fetchAll.type).mergeMap(({payload}) => {
        const fetchObservables = Observable.merge(
            fetchOccupancyDataObservable(payload.organizationId, payload.refresh, payload.year),
            fetchLeaversAndJoinersObservable(payload.organizationId, payload.year),
            fetchEnrolledDataObservable(payload.organizationId, payload.year),
            fetchRegisteredEmployeesObservable(payload.organizationId, payload.year),
            fetchEmployeeSickDaysObservable(payload.organizationId, payload.year),
            fetchRevenueReportObservable(
                payload.organizationId,
                REVENUE_TARGET_TYPES.ORGANIZATON,
                `${payload.year}-${FIRST_DAY_OF_YEAR}`,
                `${payload.year}-${LAST_DAY_OF_YEAR}`,
                payload.refresh,
                action$,
                payload.revenueFilter,
            ).flatMap(({actions}) => actions),
        );

        const onComplete = fetchObservables.count().map(() => Actions.fetchAllSuccess.action());
        return Observable.merge(fetchObservables, onComplete).catch(e =>
            Observable.of(Actions.fetchAllFailed.action(e)),
        );
    });

const includeForecast = action$ =>
    action$
        .ofType(Actions.filterRevenue.type)
        .mergeMap(({payload}) =>
            fetchRevenueReportObservable(
                payload.organizationId,
                REVENUE_TARGET_TYPES.ORGANIZATON,
                payload.year,
                false,
                undefined,
                payload.revenueFilter,
            ).flatMap(({actions}) => actions),
        );

export default combineEpics(
    fetchOccupancyData,
    fetchEnrolledData,
    fetchRegisteredEmployees,
    fetchLeaversAndJoiners,
    fetchEmployeeSickDays,
    refreshAll,
    includeForecast,
);
